"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.btnStyleActive = exports.btnStyle = void 0;

var _react = _interopRequireDefault(require("react"));

var _Button = _interopRequireDefault(require("@mui/material/Button/Button.js"));

var _CircularProgress = _interopRequireDefault(require("@mui/material/CircularProgress/CircularProgress.js"));

var _makeStyles = _interopRequireDefault(require("@mui/styles/makeStyles/makeStyles.js"));

var _Colors = _interopRequireDefault(require("../../styles/Colors"));

var _excluded = ["label", "className", "onClick", "intent", "disabled", "isLoading", "icon", "margin", "width"],
    _excluded2 = ["buttonWrapper", "iconStyles", "iconWrapper"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var prepareIcon = function prepareIcon(classes, intent, icon, isLoading) {
  var isIcon = icon ? icon(intent === 'tertiary' ? _Colors.default.secondaryGrey : _Colors.default.white) : null;
  var styledIcon = isLoading ? /*#__PURE__*/_react.default.createElement("div", {
    className: classes.iconStyles
  }, /*#__PURE__*/_react.default.createElement(_CircularProgress.default, {
    color: "inherit",
    size: 24
  })) : isIcon;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes.iconWrapper
  }, styledIcon);
};

var btnStyle = {
  primary: _Colors.default.orange,
  secondary: _Colors.default.textElementGrey,
  tertiary: 'transparent',
  success: _Colors.default.acceptGreen,
  warning: _Colors.default.warningRed
};
exports.btnStyle = btnStyle;
var btnStyleActive = {
  primary: '#B44C11',
  secondary: _Colors.default.black,
  tertiary: 'transparent',
  success: '#007400',
  warning: '#BE1327'
};
exports.btnStyleActive = btnStyleActive;

var textColor = function textColor(color, style) {
  return style === 'tertiary' ? color : _Colors.default.white;
};

var useStyle = (0, _makeStyles.default)({
  root: function root(_ref) {
    var disabled = _ref.disabled,
        intent = _ref.intent;
    return {
      height: '32px',
      transition: 'none',
      backgroundColor: disabled ? "".concat(btnStyle[intent], "80") : btnStyle[intent],
      color: textColor(_Colors.default.secondaryGrey, intent),
      fontFamily: 'Oswald',
      fontSize: 13,
      '& > span > span svg': {
        color: intent === 'tertiary' ? _Colors.default.secondaryGrey : '',
        '& > path': {
          fill: intent === 'tertiary' ? _Colors.default.secondaryGrey : ''
        }
      },
      '&.Mui-disabled': {
        color: textColor(_Colors.default.secondaryGrey, intent),
        opacity: intent === 'tertiary' ? 0.5 : 1
      },
      '&:active': {
        opacity: '1 !important',
        backgroundColor: "".concat(btnStyleActive[intent], " !important"),
        color: "".concat(intent === 'tertiary' ? _Colors.default.textElementGrey : '', " !important"),
        '& > span > span svg': {
          color: intent === 'tertiary' ? _Colors.default.textElementGrey : '',
          '& > path': {
            fill: intent === 'tertiary' ? _Colors.default.textElementGrey : ''
          }
        }
      },
      '&:focus': {
        color: intent === 'tertiary' ? _Colors.default.secondaryGrey : '',
        textShadow: intent === 'tertiary' ? '0px 0px 6px rgba(160, 160, 160, 0.5)' : 'none',
        boxShadow: intent === 'tertiary' ? 'none' : "0px 0px 6px ".concat(btnStyle[intent]),
        '& > span > span svg': {
          color: intent === 'tertiary' ? _Colors.default.tertiaryGrey : '',
          '& > path': {
            fill: intent === 'tertiary' ? _Colors.default.tertiaryGrey : ''
          }
        }
      },
      '&:hover': {
        backgroundColor: btnStyle[intent],
        color: textColor(_Colors.default.tertiaryGrey, intent),
        opacity: intent === 'tertiary' ? 1 : 0.75,
        boxShadow: intent === 'tertiary' ? 'none' : '0px 2px 4px rgba(0, 0, 0, 0.5)',
        '& > span > span svg': {
          color: intent === 'tertiary' ? _Colors.default.tertiaryGrey : '',
          '& > path': {
            fill: intent === 'tertiary' ? _Colors.default.tertiaryGrey : ''
          }
        }
      }
    };
  },
  iconStyles: function iconStyles(_ref2) {
    var intent = _ref2.intent;
    return {
      display: 'flex',
      position: 'absolute',
      right: '5px',
      color: intent === 'tertiary' ? _Colors.default.textElementGrey : _Colors.default.white
    };
  },
  iconWrapper: {
    display: 'flex',
    alignItems: 'center',
    height: '100%',
    position: 'absolute',
    right: '0px',
    bottom: '0px'
  },
  buttonWrapper: function buttonWrapper(_ref3) {
    var width = _ref3.width,
        margin = _ref3.margin;
    return {
      width: width,
      margin: margin
    };
  }
});

var Button = /*#__PURE__*/_react.default.forwardRef(function (_ref4, ref) {
  var label = _ref4.label,
      className = _ref4.className,
      onClick = _ref4.onClick,
      intent = _ref4.intent,
      disabled = _ref4.disabled,
      isLoading = _ref4.isLoading,
      icon = _ref4.icon,
      margin = _ref4.margin,
      _ref4$width = _ref4.width,
      width = _ref4$width === void 0 ? '160px' : _ref4$width,
      rest = _objectWithoutProperties(_ref4, _excluded);

  var _useStyle = useStyle({
    intent: intent,
    disabled: disabled,
    width: width,
    margin: margin
  }),
      buttonWrapper = _useStyle.buttonWrapper,
      iconStyles = _useStyle.iconStyles,
      iconWrapper = _useStyle.iconWrapper,
      classes = _objectWithoutProperties(_useStyle, _excluded2);

  return /*#__PURE__*/_react.default.createElement(_Button.default, _extends({}, rest, {
    ref: ref,
    className: "".concat(className, " ").concat(buttonWrapper),
    fullWidth: true,
    endIcon: prepareIcon({
      iconWrapper: iconWrapper,
      iconStyles: iconStyles
    }, intent, icon, isLoading),
    disableRipple: true,
    classes: classes,
    disabled: disabled,
    onClick: onClick
  }), label);
});

var _default = Button;
exports.default = _default;